import { jsx as _jsx } from "react/jsx-runtime";
import { components } from "react-select";
import { IconV2 } from "../../icon_v2";
const MultiValueRemove = (props) => {
    const selectedValues = props.selectProps.value;
    const { selectProps } = props;
    const { collapsedSelectedValues } = selectProps;
    const [first] = selectedValues;
    if (collapsedSelectedValues === true && props.data.value !== first.value) {
        return (_jsx(components.MultiValueRemove, Object.assign({}, props, { children: _jsx("div", { className: "text-primaryText dark:text-dark-primaryText mx-1 block flex size-4 min-w-[16px] items-center justify-center rounded-full", children: _jsx(IconV2, { type: "fa", icon: {
                        icon: ["far", "circle-xmark"],
                        fixedWidth: true,
                    } }) }) })));
    }
    return (_jsx(components.MultiValueRemove, Object.assign({}, props, { children: _jsx("div", { className: "text-primaryText dark:text-dark-primaryText mx-1 block flex size-4 min-w-[16px] items-center justify-center rounded-full", children: _jsx(IconV2, { type: "fa", icon: {
                    icon: ["far", "circle-xmark"],
                    fixedWidth: true,
                } }) }) })));
};
export default MultiValueRemove;
